module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "supply-list"
  }, [_c('div', {
    staticClass: "left-brand"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "brand-body"
  }, [_c('ts-input', {
    staticClass: "supply-textarea",
    attrs: {
      "type": "textarea",
      "rows": 6,
      "maxLength": 60,
      "placeholder": "请填写供应花型的详细描述，如花高，宽幅等信息"
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  }), _vm._v(" "), _c('ts-button', {
    staticClass: "supply--button button",
    attrs: {
      "type": "plain",
      "size": "large"
    },
    on: {
      "click": _vm.releaseSupply
    }
  }, [_vm._v("发布供应")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "right-list"
  }, [_c('list-tile', {
    attrs: {
      "title-text": _vm.titleText
    }
  }), _vm._v(" "), _vm._l((_vm.data), function(item) {
    return _c('div', {
      staticClass: "item-wrapper"
    }, [_c('base-item', {
      attrs: {
        "item": item,
        "type": "purchase"
      },
      on: {
        "purchaseClick": _vm.goPurchaseDetailPage
      }
    })], 1)
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brand-header"
  }, [_c('div', {
    staticClass: "brand-name"
  }, [_c('i', {
    staticClass: "arrow"
  }), _vm._v(" "), _c('i', {
    staticClass: "arrow-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('p', {
    staticClass: "brand-title"
  }, [_vm._v("厂家供应")]), _vm._v(" "), _c('p', {
    staticClass: "brand-desc"
  }, [_vm._v("海量厂家真实供货渠道")])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('i', {
    staticClass: "iconfont icon-gongying"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-6d5349bd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/homePageLists/supply-list.vue
// module id = 840
// module chunks = 39